import React from 'react';
import PropTypes from 'prop-types';

function SpecialNotes({ notes, onChange, readOnly = false, placeholder = 'Use room-temperature butter...' }) {
  const maxCharacters = 80;

  const handleInput = (e) => {
    const value = e.target.value.slice(0, maxCharacters);
    if (typeof onChange === 'function') onChange(value);
  };

  return (
    <div className="flex flex-col w-full h-full text-[#5a3e36] pt-[1%] pb-[1%]">
      <label className="text-[clamp(0.65rem,1vw,0.875rem)] font-semibold text-center mb-[1%] leading-tight">
        Special Notes:
      </label>

      {readOnly ? (
        <div className="
          w-full h-full px-[2%] py-[0.4%]
          text-[clamp(0.65rem,0.9vw,0.8rem)] leading-[clamp(0.85rem,1.1rem,1rem)]
          bg-white border border-[#e0c3a5] rounded
          whitespace-pre-wrap break-words overflow-hidden text-left
          box-border
        ">
          {notes?.trim() ? notes : <span className="text-transparent select-none">.</span>}
        </div>
      ) : (
        <textarea
          value={notes}
          onChange={handleInput}
          placeholder={placeholder}
          className="
            w-full h-full min-h-[clamp(3rem,4.5vw,4.5rem)] max-h-[clamp(4.5rem,5.5vw,5.5rem)]
            px-[2%] py-[0.3rem]
            text-[clamp(0.65rem,0.9vw,0.8rem)] leading-[clamp(0.85rem,1.1rem,1rem)]
            font-sans bg-white border border-[#e0c3a5] rounded
            resize-none box-border overflow-hidden
          "
        />
      )}
    </div>
  );
}

SpecialNotes.propTypes = {
  notes: PropTypes.string.isRequired,
  onChange: PropTypes.func,
  readOnly: PropTypes.bool,
  placeholder: PropTypes.string,
};

export default SpecialNotes;
